<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->
		<table>
			<tr>
				<th></th>
				<th></th>
			</tr>
			<tr>
				<td>{{ __("Subject") }}:</td>
				<td>{{ email.subject }}</td>
			</tr>
			<tr>
				<td>{{ __("To") }}:</td>
				<td>{{ email.to }}</td>
			</tr>
			<tr v-if="email.cc">
				<td>{{ __("Cc") }}:</td>
				<td>{{ email.cc }}</td>
			</tr>
			<tr v-if="email.bcc">
				<td>{{ __("Bcc") }}:</td>
				<td>{{ email.bcc }}</td>
			</tr>
			<tr>
				<td>{{ __("Message") }} ID:</td>
				<td>{{ message_id }}</td>
			</tr>
		</table>
		<iframe
			:srcdoc="email.body"
			width="960"
			id="messageBodyIframe"
			:style="{
				visibility: iframeVisible ? 'visible' : 'hidden',
				height: iframeHeight,
			}"
		/>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		email: {
			type: Object,
			required: true,
		},
		message_id: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			iframeVisible: false,
			iframeHeight: "2000px",
		};
	},
	mounted() {
		let comp = this;
		document
			.getElementById("messageBodyIframe")
			.addEventListener("load", function () {
				let that = this;
				setTimeout(function () {
					comp.iframeHeight =
						that.contentWindow.document.body.offsetHeight + "px";
					comp.iframeVisible = true;
				}, 100);
			});
	},
};
</script>
